module.exports = __webpack_public_path__ + "img/3.8b9376d1.png";